<template>
  <transition name="bounce">
    <div class="modal" v-if="show">
      <div class="bg"></div>
      <div class="container" :style="{width: width, height: height}">
        <slot name="header">
          <header>
            {{title}}
            <i @click="close" class=" icons icon-close-win close-btn" v-if="closeShow"></i>
          </header>
        </slot>
        <div class="content">
          <slot name="content"></slot>
        </div>
        <slot name="footer">
          <div class="footer" v-if="footerBtnShow">
            <a href="javscript:void(0)" class="btn make-sure" @click.prevent="sure">{{okBtnText}}</a>
            <a href="javscript:void(0)" class="btn cancel" @click.prevent="cancel">{{cancelBtnText}}</a>
          </div>
        </slot>

      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
export default {
  name: 'modal',
  props: {
    width: {
      type: String,
      default: '430px'
    },
    height: {
      type: String,
      default: '183px'
    },
    title: {
      type: String,
      default: '信息'
    },
    show: {
      type: Boolean,
      default: false
    },
    closeShow: {
      type: Boolean,
      default: true
    },
    footerBtnShow: {
      type: Boolean,
      default: true
    },
    okBtnText: {
      type: String,
      default: '确定'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    onSure: {
      type: Function
    },
    onCancel: {
      type: Function
    }
  },
  data() {
    return {
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
      if (this.onCancel) this.onCancel()      
    },
    cancel() { 
      this.$emit('update:show', false)
      if (this.onCancel) this.onCancel()
    },
    sure() {    
      this.$emit('update:show', false)
      if (this.onSure) {
        this.onSure()
      }
    }
  }
}
</script>

<style lang="scss">
.bounce-enter-active {
    transform: scale(2);
    opacity: 0;
    transition: all 0.3s;
}
.bounce-leave-active {
    transform: scale(1.5);
    opacity: 0;
    transition: all 0.3s;
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: #000;
        opacity: 0.4;
        z-index: 99;
    }
    .container {
        border-radius: 2px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        z-index: 999;
    }
}
.modal {
    header {
        // width: 91.666%;
        height: 36px;
        line-height: 36px;
        background: #efefef;
        border-radius: 2px;
        font-size: 12px;
        font-weight: bold;
        color: #84848b;
        // margin: 16px auto 0;
        padding: 0 16px;
    }
    .content {
        font-size: 12px;
        // font-weight: bold;
        text-align: center;
        width: 100%;
        min-height: 83px;
        // padding-top: 40px;
        color: #000;
    }
    .footer {
        // position: absolute;
        // bottom: 0;
        width: 100%;
        padding: 10px 0;
        height: 52px;
        background-color: #fff;
        text-align: right;
        border-top: 1px solid #d0d0d0;
    }
    .btn {
        display: inline-block;
        width: 100px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        margin-right: 16px;
        border-radius: 2px;
    }
    .btn.make-sure {
        background-color: #457eec;
        color: #fff;
        &:hover {
            background-color: #0f409f;
        }
    }
    .btn.cancel {
        background-color: #fff;
        // box-shadow: 0 0 1px #b8b8b8 inset;//windows 火狐浏览器不支持?
        border:1px solid #b8b8b8;
        color: #434354;
        &:hover {
            // box-shadow: 0 0 1px #84848b inset;
            border:1px solid #84848b;
        }
    }
    .close-btn {
        cursor: pointer;
        float: right;
        margin-top: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/modal.vue